<category-component></category-component>
<div class="product-detail-wrapper  grey-color fixed-header-height">
    <div class="container-fluid" *ngIf="product">
        <div class="row">
            <div class="col-12">
              <a (click)="goBack()"  class="back-listing-btn mt-4 mb-0 mt-md-0 mb-md-4" title="back">
                <svg width="15px" height="16px" viewBox="0 0 15 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <title>Combined Shape</title>
                    <desc>Created with Sketch.</desc>
                    <g id="SCREENS" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="210209_shopboss_cart" transform="translate(-1719.000000, -1333.000000)" fill="#D9394C" fill-rule="nonzero">
                            <path d="M1726.46967,1333.46967 L1727.53033,1334.53033 L1721.811,1340.24967 L1734,1340.25 L1734,1341.75 L1721.811,1341.74967 L1727.53033,1347.46967 L1726.46967,1348.53033 L1719.46967,1341.53033 C1719.2034,1341.26406 1719.1792,1340.8474 1719.39705,1340.55379 L1719.46967,1340.46967 L1726.46967,1333.46967 Z" id="Combined-Shape"></path>
                        </g>
                    </g>
                </svg>
                Back
            </a>
                <ul class="breadcrumbs d-flex pt-3 pt-md-0">
                    <li>
                        <a routerLink="/" title="Home">Home</a>
                    </li>
                    <li class="seperator-arrow">
                        <span> <img src="../../assets/images/seperator-arrow.svg" alt="seperator-arrow" /> </span>
                    </li>
                    <li>
                        
                        <a  [routerLink]="['/product/listing/' + product.category_id + '-' + product.category_url_key]" title="{{product.category_name}}">{{product.category_name}}</a>
                    </li>
                    <li class="seperator-arrow">
                        <span> <img src="../../assets/images/seperator-arrow.svg" alt="seperator-arrow" /> </span>
                    </li>
                    <li>
                       {{product.name}}
                    </li>
                </ul>
            
            </div>
            <div class="col-12 col-xl-6 no-mobile-padding">
                <product-view-slider [ImagesData]="product.images"></product-view-slider>
            </div>
            <div class="col-12 col-xl-6">
                <div class="product-detail">
                    <div class="in-stock d-block d-md-none"  >
                        <p *ngIf="product.is_in_stock == 1">
                            <img src="../../assets/images/in-stock-icon.svg" alt="in-stock-icon">
                            In Stock
                        </p>
                        <p *ngIf="product.back_in_stock == '0'" > <img src="../../assets/images/cross-round.svg" alt="cross icon"/>Out of stock.</p>
                    </div>
                    <h2>{{product.name}}</h2>
                    <ul class="product-type" *ngIf="product.price_marked == 1">
                        <li>
                          <img
                          src="../../assets/images/pmp.svg" alt="checked icon" />
                        </li>
                    </ul>
                    <div class="in-stock d-none d-md-block"  >
                        <p *ngIf="product.is_in_stock == 1">
                            <img src="../../assets/images/in-stock-icon.svg" alt="in-stock-icon">
                            In Stock
                        </p>                      
                    </div>
                    
                        <ul class="product-credentials" [ngClass]="{'show':global_data?.price_visibility == 1}">
                            <li class="pl-0">
                                <span>RSP</span>
                                <p> <span class="text-dark" *ngIf="product.rsp !== '0.00'">£{{product.rsp}}</span>
                                    <span class="text-dark" *ngIf="product.rsp == '0.00'">N/A</span>  
                                    <span class="each" *ngIf="product.rsp != '0.00' && (product.sale_unit != '' && (product.sale_unit == 'Kilo' || product.sale_unit == 'Each'))"> per 100g</span>
                                    <span class="each" *ngIf="product.rsp != '0.00' && (product.sale_unit != '' && product.sale_unit?.indexOf('C') !== -1)"> each</span>
                                </p>
                            </li>
                            <li *ngIf="global_data?.margin_visibility == 1">
                              <span>Margin</span>
                              <p><span class="text-dark"> {{product.margin}}%</span></p>
                            </li>

                            <li class="border-none" *ngIf="global_data?.price_visibility == 1">
                                <span>Cost</span>
                                <p>£{{product.price}}</p>
                            </li>
                            <li class="border-none">
                                <span>Case</span>
                                <p>{{product.size_case}}</p>
                            </li>
                            
                            <li class="padding-left-zero" *ngIf="global_data?.price_visibility == 1 && global_data?.vat_exempt == 0">
                                <span>VAT</span>
                                <p>{{product.vat}}%</p>
                            </li>
                            <li>
                                <span>Product Code</span>
                                <p>{{product.sku}}</p>
                            </li>
                            <li class="border-none1">
                                    <span>Barcode</span>
                                    <p>{{product.barcode}}</p>
                                </li>
                        </ul>  
                   
                    <div class="divider m-0"></div>
                    <div class="add-to-cart" #stickyMenu
                    [class.sticky] = "sticky">
                        <div class="left-column">
                            <div class="spinner">
                                <ngx-number-spinner [ngClass]="{'disabled':product.back_in_stock == '0' ?true : false}" *ngIf="product.item_id == ''" [value]="qyt" [min]="1" (change)="qytChange($event)">
                                </ngx-number-spinner>

                                <ngx-number-spinner [ngClass]="{'disabled':product.back_in_stock == '0' ?true : false}" [value]="qyt" [min]="0" (change)="qytChange($event, removeFromcartTemplate)" *ngIf="product.item_id != ''">
                                </ngx-number-spinner>
                            </div>
                            <div class="price" *ngIf="global_data?.price_visibility == 1 && product.row_total != ''">
                                £{{product.row_total}}
                            </div>
                        </div>
                      <div class="right-column">

                      
                            <button *ngIf="miniCartDetails.items_count != 0" [ngClass]="{'btn primary-btn':true, 'disabled':product.back_in_stock == '0' ?true : false}" (click)="product.item_id != '' ? qytUpdate() : addToCart('',commonTemplate,commonTemplateFor24HrPopup,true)">{{cartButtonText}}</button>
                            <button *ngIf="miniCartDetails.items_count == 0" [ngClass]="{'btn primary-btn':true, 'disabled':product.back_in_stock == '0' ?true : false}" (click)="product.item_id != '' ? qytUpdate() : addToCart(addToCartTemplate, commonTemplate,commonTemplateFor24HrPopup,true)">{{cartButtonText}}</button>
                            <p class="product-cart-status" *ngIf="product.item_id != ''"><img src="../../assets/images/checkmark.svg" alt="checked icon"/>  This product is already in your cart.</p>
                           
                            <div class="in-stock d-none d-md-flex mt-3 justify-content-center "  >
                              <p *ngIf="product.back_in_stock == '0'" > <img src="../../assets/images/cross-round.svg" alt="cross icon"/>Out of stock.</p>
                          </div>
                          </div>
                    </div>
                    <div class="product-description">
                      <h3>Product Description</h3>
                      <p>{{product.description}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #addToCartTemplate>
    <div class="modal-header border-0 pb-2 align-items-center  flex-column">
        <h4 class="modal-title">Info</h4>
        <p>You are about to create a order for</p>
        <h4 class="modal-title">{{selectedStore.selectedStoreName}}</h4>
    </div>
    <div class="modal-body py-0 px-0">
      <div class="row">
        <div class="col-md-12">
          <div class="text-center">
            <p>Please change the store if you want to create an order for another store.</p>
          </div>
          <div class="button-success text-center mt-3">
            <button class="common-button mr-3" (click)="bsModalRef.hide()">Ok</button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #commonTemplate>
    <div class="modal-header border-0 pb-2 align-items-center">
        <h4 class="modal-title">Info</h4>
    </div>
    <div class="modal-body py-0 px-0">
      <div class="row">
        <div class="col-md-12">
          <div class="text-center">
            <p>{{popupMessage}} </p>
          </div>
          <div class="button-div text-center mt-3 align-items-center">
            <button class="common-button mr-3" (click)="bsModalRef.hide()">{{commonButtonText}}</button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #removeFromcartTemplate>
    <div class="modal-header border-0 pb-2" >
      <h4 class="modal-title">Confirmation!</h4>
      <button type="button" data-dismiss="removeFromcartTemplate" class="close  " aria-label="Close" (click)="cancleRequest()">
        <span aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <g fill="none" fill-rule="evenodd">
              <g stroke="#9B9B9B" stroke-width="1.75">
                <g>
                  <g>
                    <path d="M14 0L0 14M0 0L14 14"
                      transform="translate(-1190 -462) translate(695 443) translate(496 20)" />
                  </g>
                </g>
              </g>
            </g>
          </svg></span>
      </button>
    </div>
    <div class="modal-body py-0 px-0">
      <div class="row">
        <div class="col-md-12">
          <div class="text-center">
            <p>Are you sure you want to remove product from cart?</p>
          </div>
          <div class="button-div text-center mt-3">
            <button class="common-button mr-3" (click)="cancleRequest(removeProduct)">Cancel</button>
            <button class="common-button ghost" (click)="removeItem(removeProduct)">Confirm</button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #commonTemplateFor24HrPopup>
    <div class="modal-header border-0 pb-2 align-items-center">
        <h4 class="modal-title">Info</h4>
    </div>
    <div class="modal-body py-0 px-0">
      <div class="row">
        <div class="col-md-12">
          <div class="text-center">
            <p style="white-space: pre-wrap">{{popupMessage}} </p>
          </div>
          <div class="button-div text-center mt-3 align-items-center">
            <button class="common-button mr-3" (click)="bsModalRef.hide()">Cancel</button>
            <button class="common-button mr-3" (click)="addToCart(addToCartTemplate, commonTemplate,commonTemplateFor24HrPopup,false)">{{commonButtonText}}</button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>